import*as r from"react";var a=r["use".trim()];export{a as default};
